import { stripUrlProtocol } from '@/lib/string/string-validators'

export const normalizeFaviconHost = (domain: string): string =>
  stripUrlProtocol(domain).split(/[/?#]/)[0].trim()

export const getFaviconUrl = (domain: string): string => {
  const host = normalizeFaviconHost(domain)
  return `https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://${host}&size=64`
}
